import React from "react";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { User, Trash2 } from "lucide-react";

interface AvatarItemProps {
  id: number;
  url: string;
  alt: string;
  isSelected: boolean;
  isDefault: boolean;
  onSelect: (id: number) => void;
  onDelete?: (id: number) => void;
}

export const AvatarItem = ({
  id,
  url,
  alt,
  isSelected,
  isDefault,
  onSelect,
  onDelete,
}: AvatarItemProps) => {
  return (
    <div className="relative flex items-center space-x-4 p-4 border rounded-lg hover:bg-accent transition-colors">
      <Checkbox
        id={`avatar-${id}`}
        checked={isSelected}
        onCheckedChange={() => onSelect(id)}
        className="absolute top-4 right-4"
      />
      <Avatar className="h-16 w-16 border-2 border-primary">
        <AvatarImage src={url} alt={alt} className="object-cover" />
        <AvatarFallback>
          <User className="h-8 w-8" />
        </AvatarFallback>
      </Avatar>
      <div className="flex-1">
        <p className="text-sm font-medium">Avatar {id}</p>
        <p className="text-sm text-muted-foreground">{alt}</p>
      </div>
      {!isDefault && onDelete && (
        <Button
          variant="ghost"
          size="icon"
          className="absolute bottom-4 right-4"
          onClick={() => onDelete(id)}
        >
          <Trash2 className="h-4 w-4 text-destructive" />
        </Button>
      )}
    </div>
  );
};